import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { EntityIndKatFields } from "./editCategorieFields";
import React from "react";
export default class EditCategorieFieldApp extends React.Component<EditCategorieFieldProps, any> {
    common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        if (this.props.entity.IsNew)
            this.setMaxPos();
    }

    setMaxPos = () => {
        HTTPService.get<JsonResultClass<number>>("IndividualCategory/GetMaxPos", { kat: this.props.entity.Kat }).then(result => {
            if (result.Code === 0) {
                this.props.entity.Pos = result.Data;
                this.setState({});
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    save = (closeAfterSave) => {
        if (this.common.validate()) {
            this.internalSave(closeAfterSave);
        }
    }

    internalSave = (closeAfterSave) => {
        HTTPService.post<JsonResultClass<EntityIndKatFields>>("IndividualCategory/SaveIndKatFelder", { indKatFelder: this.props.entity }).then(result => {
            if (result.Code === 0) {
                this.props.entity.IsNew = false;
                this.props.entity.Id = result.Data.Id;
                NotificationHelper.showSuccessMessage(result.Message);
                this.setState({});
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        });
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Feld":
                this.props.entity.Feld = value;
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    getWarningMandatoryAndReadOnly = () => {
        if (this.props.entity.ReadOnly || this.props.entity.ReadOnlyExternal) {
            let individualField = this.props.dataSources.individualFieldsDataSource.find(x => x.ColumnName == this.props.entity.Feld);
            if (Helper.hasValue(individualField) && individualField.Mandatory) {
                const labelStyle: React.CSSProperties = {
                    color: "#ff0000",
                    whiteSpace: "pre-wrap"
                }
                var text = Helper.getTranslation("WebCRM.EditIndividualFields.MandatoryAndReadOnly");
                return <label style={labelStyle}>{text}</label>
            }
        }
        return null;
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} titleProps={""} />;
    }
}

export interface EditCategorieFieldProps extends AppBaseProps {
    entity: EntityIndKatFields;
    dataSources: {
        individualFieldsDataSource: any[];
    }
}